// extracted by mini-css-extract-plugin
export var imageColCustom = "MultiImageBlock-module--imageColCustom--08d96";
export var imageContainerCustom = "MultiImageBlock-module--imageContainerCustom--ece5c";
export var imageRowCustom = "MultiImageBlock-module--imageRowCustom--7efc3";